import React from 'react';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  title: 'MEGA RACCOLTA DI VALUTAZIONI SPECIALISTICHE™',
  description: "Una raccolta professionale di strumenti dedicati alla valutazione clinica avanzata. Include modelli per valutazione iniziale, rivalutazione e dimissione, profilo occupazionale, analisi delle performance, schede per il ragionamento clinico, definizione degli obiettivi terapeutici, checklist operative e documentazione pronta all'uso per pazienti pediatrici, neurologici, geriatrici e adulti."
}, {
  title: 'PROGRAMMI INTENSIVI PER LE ATTIVITÀ DELLA VITA QUOTIDIANA™',
  description: "Un sistema completo dedicato al recupero e al mantenimento dell'autonomia nelle attività della vita quotidiana. Include programmi strutturati per alimentazione, igiene personale, vestizione, trasferimenti, mobilità domestica, organizzazione della routine e gestione funzionale delle attività, con progressioni, adattamenti e materiali immediatamente utilizzabili."
}, {
  title: 'KIT PROFESSIONALE DI ADATTAMENTI E AUSILI™',
  description: "Una raccolta completa di protocolli dedicati all'adattamento funzionale. Comprende strategie compensative, adattamenti ambientali, criteri per la selezione degli ausili, ergonomia, conservazione dell'energia, materiali per caregiver, checklist operative e strumenti pratici pronti da integrare negli interventi terapeutici."
}, {
  title: 'REPORT CLINICI E DOCUMENTAZIONE PROFESSIONALE™',
  description: 'Un sistema professionale per semplificare la gestione della documentazione clinica. Include relazioni periodiche, report di rivalutazione, documenti interdisciplinari, schede di monitoraggio, comunicazioni per famiglie, scuole e strutture sanitarie, oltre a modelli personalizzabili pronti per differenti contesti professionali.'
}, {
  title: 'MEGA KIT DI MATERIALI TERAPEUTICI STAMPABILI™',
  description: "Una raccolta completa di risorse operative pronte all'uso. Include attività cognitive, esercizi per motricità fine, coordinazione, percezione visiva, attenzione, memoria, funzioni esecutive e autonomia personale, organizzati per obiettivo clinico e livello di difficoltà, già pronti per essere stampati e utilizzati durante le sedute."
}];
const outcomes = [{
  emoji: '⚡',
  title: 'Risparmia Ore Ogni Settimana',
  desc: 'Smetti di creare valutazioni, programmi terapeutici, attività e documentazione da zero. Apri il sistema, scegli il materiale, personalizzalo se necessario e prepara settimane di intervento in pochi minuti.'
}, {
  emoji: '👑',
  title: 'Lavora con Maggiore Professionalità',
  desc: 'Organizza il tuo lavoro con un sistema completo composto da valutazioni, programmi terapeutici, attività, protocolli, documentazione e strumenti professionali già pronti. Offri ai tuoi pazienti un intervento più organizzato, efficace e professionale.'
}, {
  emoji: '🤝',
  title: 'Migliora la Qualità dei Tuoi Interventi',
  desc: 'Utilizza programmi strutturati, progressioni terapeutiche e strumenti di monitoraggio che ti permettono di seguire ogni paziente con maggiore precisione, continuità ed efficacia durante tutto il percorso terapeutico.'
}, {
  emoji: '😊',
  title: 'Concentrati Finalmente Sui Tuoi Pazienti',
  desc: "Dedica meno tempo alla preparazione delle attività e della documentazione e più tempo a valutare, osservare, intervenire e favorire l'autonomia dei tuoi pazienti. È questo il vero lavoro di un Terapista Occupazionale."
}];
export function BonusSection() {
  return <>
      <section className="border-y border-brand-gold/40 bg-brand-cloud px-4 py-5" data-id="element-15" data-mp="9aok6frah2a7">
        <div className="mx-auto max-w-4xl" data-id="element-16" data-mp="ea02ht7b0ftw">
          <h2 className="mb-3 text-center font-display text-xl font-extrabold uppercase sm:text-3xl" data-id="element-17" data-mp="e8ygitor28xe">
            🎁 IN PIÙ RICEVERAI 5 BONUS ESCLUSIVI
          </h2>
          <div className="grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-18" data-mp="2z237q1rqspnt">
            {bonuses.map((bonus, i) => <article key={bonus.title} className="rounded-xl border border-brand-gold/45 bg-white p-3 text-center shadow-sm" data-id="element-19" data-mp="3f9pwoweww0lb" data-mpi={i}>
                <div className="mx-auto mb-2 flex h-9 w-9 items-center justify-center rounded-full border border-brand-gold/50 bg-brand-gold/15" data-id="element-20" data-mp="3aflok9twtmin">
                  <GiftIcon className="h-4 w-4 text-brand-gold" data-id="element-21" data-mp="30k1xq1u7de0r" />
                </div>
                <h3 className="mb-1 font-display text-[13px] font-bold leading-tight text-brand-ink" data-id="element-22" data-mp="226cgug5ezlt">
                  🎁 BONUS {i + 1} — {bonus.title}
                </h3>
                <p className="text-xs font-medium leading-snug text-brand-slate" data-id="element-23" data-mp="3o8uu1zeqlnvw">
                  {bonus.description}
                </p>
              </article>)}
          </div>
        </div>
      </section>

      <section className="bg-white px-4 py-5" data-id="element-24" data-mp="2cu7jbfu8jhee">
        <div className="mx-auto max-w-4xl" data-id="element-25" data-mp="2cuzewqnu1f4o">
          <h2 className="mb-3 text-center font-display text-xl font-extrabold uppercase sm:text-3xl" data-id="element-26" data-mp="27uv0d66hiuh3">
            COSA CAMBIERÀ DA OGGI
          </h2>
          <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-27" data-mp="nedngrroxmmv">
            {outcomes.map(item => <div key={item.title} className="flex gap-3 rounded-r-xl border-l-4 border-brand-navy bg-brand-cloud p-3 shadow-sm" data-id="element-28" data-mp="sc6v7p8n6op9">
                <span className="mt-0.5 shrink-0 text-xl" aria-hidden="true" data-id="element-29" data-mp="121gjsv4a1p8m">{item.emoji}</span>
                <div data-id="element-30" data-mp="1239po872g5fk">
                  <h3 className="mb-0.5 font-display text-sm font-bold uppercase tracking-wide text-brand-ink sm:text-base" data-id="element-31" data-mp="1712wn3g713gw">
                    {item.title}
                  </h3>
                  <p className="text-xs font-medium leading-snug text-brand-slate sm:text-sm" data-id="element-32" data-mp="1g1841dle01v2">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>
    </>;
}